export const testimonials = [
  {
    name: "Rajesh Pathre",
    review:
      "गाडी वेळेवर मिळाली आणि सर्विस खूप छान होती. ड्रायव्हर नम्र होता आणि प्रवास आरामदायक झाला. पुन्हा नक्की सेवा घेईन!",
  },
  {
    name: "Aniket Kadam",
    review:
      "Affordable rates and premium service. The car was sanitized, fuel-efficient, and perfect for our long drive. Appreciate the punctuality and professionalism of the team.",
  },
  {
    name: "Amar Kamble",
    review:
      "खूपच उत्कृष्ट कार रेंटल सेवा! गाडी अगदी स्वच्छ आणि व्यवस्थित होती. वेळेवर डिलिव्हरी मिळाली आणि संपूर्ण अनुभव खूपच छान होता.",
  },
  {
    name: "Dhanaji Pawar",
    review:
      "One of the best car rental experiences I’ve had. Transparent pricing, no hidden charges, and the vehicle was spotless. Booking process was smooth and hassle-free.",
  },
  {
    name: "Pankaj Oswal",
    review:
      "Excellent customer support and very reasonable pricing. The pickup and drop process was quick, and the car condition exceeded expectations. Highly recommended for outstation travel.",
  },
];
